<template lang='pug'>
.hub-spot-authentication
  o-auth-handler(:integration='integration'
                  :config='authConfig'
                  @authenticated='onAuthenticated'
                  @failure='onFailed')
</template>

<script>
import OAuthHandler from '@/components/OAuth/OAuthHandler';

export default {
  name: 'HubSpot',
  components: {
    OAuthHandler,
  },
  emits: ['auth-success', 'auth-failure'],
  computed: {
    integration() {
      return 'hubspot';
    },
  },
  props: {
    authConfig: {
      type: Object,
      default: null,
    },
  },
  methods: {
    onAuthenticated() {
      this.$emit('auth-success');
    },
    onFailed() {
      this.$emit('auth-failure');
    },
  },
};
</script>
